import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import AddEditPlans from './AddEditPlans'
import PlanPreview from './PlanPreview';
import { getPlans } from '@custom/rtk-apis/Setting/plans/getPlans';
import Header from '@custom/Header/Header';
import { customStyle } from '@custom/Utils/utils'
import { useTheme } from '../../../ui/src/contextProviders';
import { CheckIcon } from '@custom/Hospital/PricingCard/icons';
import { getAddons } from '@custom/rtk-apis/Setting/addons/getAddons';
import CreditsForCaseToCase from './CreditsForCaseToCase';
import { useNavigate } from 'react-router-dom';
import { _routes } from '@custom/Utils/constants/routes';
// import getCreditsPerGbApi from '@custom/rtk-apis/masterSuperAdminProfile/getCreditsPerGb';
import addEditCreditPerGbApi from '@custom/rtk-apis/masterSuperAdminProfile/addEditCreditPerGb';
import { Loader, SuccessModal } from '@ohif/ui';
import { getExtraStorage } from '@custom/rtk-apis/Setting/extraStorage/getExtraStorage';
import { Field, Form, Formik } from 'formik';
import { updateCaseCredit } from '@custom/rtk-apis/Setting/creditForCaseToCase/updateCaseCredit';
import { getCaseCredits } from '@custom/rtk-apis/Setting/creditForCaseToCase/getCaseCredits';
import { servicesManager } from '../../../app/src/App';
import editTeleModPrice from '@custom/rtk-apis/Setting/editTeleModPrice';

const PricingSettings = () => {
  const isDarkMode = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { uiNotificationService } = servicesManager.services;

  const getPlansResponse = useSelector((state: RootState) => state.getPlansResponse);
  const getAddonsResponse = useSelector((state: RootState) => state.getAddonsResponse);
  const getExtraStorageResponse = useSelector((state: RootState) => state.getExtraStorageResponse);
  const getCaseCreditResponse = useSelector((state: RootState) => state?.getCaseCreditResponse);

  const [formPlans, setFormPlans] = useState([]);
  const [formAddons, setFormAddons] = useState([]);
  const [formExtraStorage, setFormExtraStorage] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [activeDurations, setActiveDurations] = useState<{ [key: number]: 'monthly' | 'yearly' }>(
    formPlans.reduce((acc, _, index) => ({ ...acc, [index]: 'monthly' }), {})
  );
  // const [creditsPerGB, setCreditPerGb] = useState('');
  const [error, setError] = useState("");
  const [Loading, setLoading] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false)
  const [rupeeValue, setRupeeValue] = useState(1);
  const [creditSymbol, setCreditSymbol] = useState('₹');
  const [creditUpdateSuccess, setCreditUpdateSuccess] = useState(false);

  // const handleChange = (e) => {
  //   const input = e.target.value;
  //   // Allow only positive decimal numbers
  //   if (/^(\d+(\.\d*)?)?$/.test(input)) {
  //     setCreditPerGb(input);
  //     setError('');
  //   }
  // };

  // const handleUpdate = () => {
  //   const numericValue = parseFloat(creditsPerGB);
  //   if (!creditsPerGB || numericValue === 0 || isNaN(numericValue)) {
  //     setError("Credits must be greater than 0");
  //     return;
  //   }
  //   setLoading(true);

  //   dispatch(
  //     addEditCreditPerGbApi({
  //       "value": numericValue,
  //     })
  //   ).then((res) => {
  //     if (res?.payload?.success) {
  //       setSuccessPopup(true);
  //     }
  //   }).finally(() => {
  //     setLoading(false);
  //   })
  // }

  useEffect(() => {
    dispatch(getPlans());
    dispatch(getAddons());
    dispatch(getExtraStorage());
    // dispatch(getCreditsPerGbApi()).then((res) => {
    //   const value = res?.payload?.data?.value;
    //   setCreditPerGb(value);
    // });
  }, [dispatch]);

  useEffect(() => {
    if (getPlansResponse?.success && getPlansResponse?.plans?.data?.length > 0) {
      // Handle potential differences in data structure from API
      const updatedPlans = getPlansResponse?.plans?.data?.map((plan: any) => {
        // If the plan already has monthly and yearly configs, use them directly
        if (plan.monthly && plan.yearly) {
          return plan;
        }

        // If the plan is in the old format, convert it to the new format
        // by copying the old fields to both monthly and yearly
        if (!plan.monthly && !plan.yearly) {
          const { name, _id, ...otherProps } = plan;
          return {
            _id,
            name,
            monthly: { ...otherProps },
            yearly: {
              ...otherProps,
              // Adjust yearly values if needed
              extraCaseRate: Math.max(1, otherProps.extraCaseRate * 0.8), // 20% discount for yearly
              cloudStorage: otherProps.cloudStorage.replace('1 Month', '12 Months')
            }
          };
        }

        return plan;
      });

      setFormPlans(updatedPlans);

      // Initialize active durations for all plans
      setActiveDurations(
        updatedPlans?.reduce((acc, _, index) => ({ ...acc, [index]: 'monthly' }), {})
      );
    }
  }, [getPlansResponse]);

  const handleRupeeUpdate = (values) => {
      setRupeeValue(values.rupeeValue);
      const payload = { creditValue: values.rupeeValue, creditSymbol: values.creditSymbol };
      dispatch(updateCaseCredit(payload)).then((response: any) => {
          if (response?.meta?.requestStatus === 'fulfilled') {
              setCreditUpdateSuccess(true);
              dispatch(getCaseCredits());
          }
          else if(response?.meta?.requestStatus === 'rejected'){
              uiNotificationService.show({
                  title: 'Credit',
                  message: response?.payload,
                  type: 'error',
              });
          }
      });
  };

  useEffect(() => {
    if (getCaseCreditResponse?.status === 'SUCCESS') {
      setRupeeValue(getCaseCreditResponse.fullDoc?.creditValue);
      setCreditSymbol(getCaseCreditResponse.fullDoc?.creditSymbol);
    }
  }, [getCaseCreditResponse]);

  useEffect(() => {
    if (getAddonsResponse?.success && getAddonsResponse?.result?.data?.length > 0) {
      setFormAddons(getAddonsResponse?.result?.data);
    }
  }, [getAddonsResponse])

  useEffect(() => {
    if (getExtraStorageResponse?.success) {
      setFormExtraStorage(getExtraStorageResponse?.result?.plans);
    }
  }, [getExtraStorageResponse])

  const currencyOptions = [
    { value: "₹", label: "₹" },
    // { value: "$", label: "$" },
    // { value: "AED", label: "AED" },
    // { value: "€", label: "€" }
  ];

  return (
    <div className="page page__full" style={
      isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    }>
      <Header title="Plan Settings" />
      <div className="page__body">
        {
          <>
            <div className="btn__group custom__plan__btn" style={{
              justifyContent: isEditMode ? "flex-end" : "space-between",
              alignItems: "center",
            }}>
              {!isEditMode &&
                <h2 className='form__section__title' style={{ marginLeft: "1rem" }}>
                  Plan Settings
                </h2>}
              <button className='btn btn__white' onClick={() => {
                setIsEditMode((curr) => !curr);
              }}>{isEditMode ? 'Preview Plans' : 'Edit Plans'}</button>
            </div>
          </>
        }
        {
          isEditMode ? (
            <AddEditPlans formPlans={formPlans} activeDurations={activeDurations} setActiveDurations={setActiveDurations} setIsEditMode={setIsEditMode} />
          ) : (
            <PlanPreview formPlans={formPlans} />
          )
        }
        {!isEditMode &&
          <>
            <div className="btn__group custom__plan__btn" style={{
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <h2 className='form__section__title' style={{ marginLeft: "1rem" }}>
                Add-on Settings
              </h2>
              <button
                className='btn btn__white'
                onClick={() => {
                  navigate(_routes.settings.addEditAddOns);
                }}
              >
                Edit Add-ons
              </button>
            </div>
            <AddOnsPreview formAddons={formAddons} isDarkMode={isDarkMode} />
          </>
        }
        {!isEditMode &&
          <>
            <div className="btn__group custom__plan__btn" style={{
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <h2 className='form__section__title' style={{ marginLeft: "1rem" }}>
                Extra Storage Settings
              </h2>
              <button
                className='btn btn__white'
                onClick={() => {
                  navigate(_routes.settings.addEditExtraStorage);
                }}
              >
                Edit Extra Storage
              </button>
            </div>
            <ExtraStoragePreview formExtraStorage={formExtraStorage} isDarkMode={isDarkMode} />
          </>
        }
        {/* Credit per GB start */}
        {/* {
          !isEditMode && (
            <>
              <h2 className="form__section__title" style={{ marginLeft: "1rem", marginTop: "1rem", marginBottom: "1rem" }}>Credits per GB</h2>
              <div className="bg-[#f4ffff] p-6 rounded-lg shadow-md ml-5 mb-1" style={{ width: "97%" }}>

                <div className="flex items-center justify-start gap-4">
                  <div className="flex flex-col">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Enter the credits<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={creditsPerGB}
                      onChange={handleChange}
                      style={{ width: "25rem" }}
                      className="border border-gray-400 bg-transparent rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                    {error && <span className="text-red-600 text-sm mt-1">{error}</span>}
                  </div>

                  <button onClick={handleUpdate} className="bg-teal-600 text-white px-4 py-2 rounded-md mt-6 hover:bg-teal-700 flex items-center gap-2">
                    Update
                  </button>
                </div>
              </div>
            </>
          )} */}
        {/* Credit per GB end */}
        {!isEditMode &&
          <>
            <div className="btn__group custom__plan__btn" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 className='form__section__title' style={{ marginLeft: '1rem' }}>
                Credits for case-to-case Settings
              </h2>
              <button
                className='btn btn__white'
                onClick={() => {
                  navigate(_routes.settings.addEditCreditForCaseToCase);
                }}
              >
                Add credits plan
              </button>
            </div>
            <CreditsForCaseToCase />
          </>
        }
      </div>
      <Loader isLoaderOpen={Loading} />
      <SuccessModal isSuccessModalOpen={successPopup} title={'Credits updated successfully.'} handleCloseModal={() => setSuccessPopup(false)} />
    </div>
  )
}

export default PricingSettings


const AddOnsPreview = ({ formAddons, isDarkMode }) => {
  return (
    <div className="addon-cards-container" style={{ marginInline: "1rem", marginTop: "1rem", background: "transparent" }}>
      {formAddons?.map((addon) => (
        <div
          className={`addon-card`}
          style={{
            background: 'transparent',
            border: '1px solid #e0e0e0',
          }}
          key={addon?._id}
        >
          <div className={`addon-card-header`}>
            {/* {addon.recommended && <div className="recommended-badge">Recommended</div>} */}
            <h3>{addon?.name}</h3>
            <p className="price">+₹{addon?.price}/mo</p>
          </div>

          <div className={`addon-card-body`}>
            <ul className="features-list">
              {addon?.features.map((feature, index) => (
                <li className={`feature-item`} key={index}>
                  <CheckIcon />
                  <span style={{
                    color: isDarkMode?.isDarkMode ? '#fff' : '#4a5568'
                  }}>{feature?.point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  )
}

const ExtraStoragePreview = ({ formExtraStorage, isDarkMode }) => {
  console.log("formExtraStorage", formExtraStorage);
  if (!formExtraStorage || formExtraStorage.length === 0) {
    return (
      <div style={{ textAlign: 'center', margin: '1rem 0', color: isDarkMode?.isDarkMode ? '#fff' : '#4a5568' }}>
        No Extra Storage available
      </div>
    );
  }
  return (
    <div className="addon-cards-container" style={{ marginInline: "1rem", marginTop: "1rem", background: "transparent" }}>
      {formExtraStorage?.map((addon) => (
        <div
          className={`addon-card`}
          style={{
            background: 'transparent',
            border: '1px solid #e0e0e0',
          }}
          key={addon?._id}
        >
          <div className={`addon-card-header`}>
            {/* {addon.recommended && <div className="recommended-badge">Recommended</div>} */}
            <h3>{addon?.planName}</h3>
            <p className="price">{addon?.creditsPerGB} credits per GB</p>
          </div>

          <div className={`addon-card-body`}>
            <ul className="features-list">
              <li className={`feature-item`}>
                <CheckIcon />
                <span style={{
                  color: isDarkMode?.isDarkMode ? '#fff' : '#4a5568'
                }}>{addon?.frequency} months</span>
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  )
}
